// import React, { useEffect, useRef } from "react";
// import ReactQuill, { Quill } from "react-quill";
// import "react-quill/dist/quill.snow.css";

// const Parchment = Quill.import("parchment");
// const LineHeightStyle = new Parchment.Attributor.Style(
//   "lineheight",
//   "line-height",
//   { scope: Parchment.Scope.BLOCK }
// );
// Quill.register(LineHeightStyle, true);

// const LINE_HEIGHTS = ["1", "1.2", "1.5", "1.8", "2", "2.5", "3"];

// export default function MyEditor({ value = "", onChange }) {
//   const quillRef = useRef(null);
//   const selectRef = useRef(null);

//   useEffect(() => {
//     const editor = quillRef.current?.getEditor();
//     if (!editor) return;

//     const toolbar = editor.getModule("toolbar")?.container;
//     if (!toolbar || toolbar.querySelector(".ql-lineheight")) return;

//     const container = document.createElement("span");
//     container.className = "ql-formats";

//     const select = document.createElement("select");
//     select.className = "ql-lineheight";
//     select.style.width = "60px";
//     select.style.fontSize = "12px";
//     select.style.cursor = "pointer";

//     selectRef.current = select;

//     const placeholder = document.createElement("option");
//     placeholder.value = "";
//     placeholder.innerText = "LH";
//     placeholder.disabled = true;
//     placeholder.hidden = true;
//     select.appendChild(placeholder);

//     LINE_HEIGHTS.forEach(lh => {
//       const option = document.createElement("option");
//       option.value = lh;
//       option.innerText = lh;
//       select.appendChild(option);
//     });

//     select.addEventListener("change", e => {
//       const lh = e.target.value;
//       const length = editor.getLength();

//       if (!lh) {
//         editor.formatLine(0, length, "lineheight", false);
//       } else {
//         editor.formatLine(0, length, "lineheight", lh);
//       }
//     });

//     container.appendChild(select);
//     toolbar.appendChild(container);
//   }, []);


//   useEffect(() => {
//     const editor = quillRef.current?.getEditor();
//     const select = selectRef.current;
//     if (!editor || !select) return;

//     requestAnimationFrame(() => {
//       const format = editor.getFormat();

//       if (format.lineheight) {
//         select.value = format.lineheight;
//       } else {
//         select.value = ""; 
//       }
//     });
//   }, [value]);

//   const modules = {
//     toolbar: [
//       [{ header: [1, 2, 3, false] }],
//       ["bold", "italic", "underline"],
//       [{ list: "ordered" }, { list: "bullet" }],
//       [{ align: [] }]
//     ]
//   };

//   return (
//     <ReactQuill
//       ref={quillRef}
//       value={value}
//       onChange={onChange}
//       theme="snow"
//       modules={modules}
//       placeholder="Type something..."
//       style={{ height: "250px" }}
//     />
//   );
// }

import React, { useEffect, useRef } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";

const Parchment = Quill.import("parchment");

const LineHeightStyle = new Parchment.Attributor.Style(
  "lineheight",
  "line-height",
  { scope: Parchment.Scope.BLOCK }
);

Quill.register(LineHeightStyle, true);

const LINE_HEIGHTS = ["1", "1.2", "1.5", "1.8", "2", "2.5", "3"];

export default function MyEditor({ value = "", onChange }) {
  const quillRef = useRef(null);
  const selectRef = useRef(null);

  useEffect(() => {
    if (document.getElementById("quill-editor-css")) return;

    const style = document.createElement("style");
    style.id = "quill-editor-css";
    style.innerHTML = `
      .quill-wrapper {
        border: 1px solid #e5e7eb;
        border-radius: 6px;
        background: white;
      }

      .quill-wrapper .ql-toolbar {
        position: sticky;
        top: 0;
        z-index: 10;
        background: white;
        border-bottom: 1px solid #e5e7eb;
      }

      .quill-wrapper .ql-container {
        height: 260px;
      }

      .quill-wrapper .ql-editor {
        max-height: 200px;
        overflow-y: auto;
        padding: 12px;
      }

      .ql-lineheight {
        width: 55px;
        font-size: 12px;
        cursor: pointer;
      }
    `;

    document.head.appendChild(style);
  }, []);

  useEffect(() => {
    const editor = quillRef.current?.getEditor();
    if (!editor) return;

    const toolbar = editor.getModule("toolbar")?.container;
    if (!toolbar || toolbar.querySelector(".ql-lineheight")) return;

    const container = document.createElement("span");
    container.className = "ql-formats";

    const select = document.createElement("select");
    select.className = "ql-lineheight";

    selectRef.current = select;

    const placeholder = document.createElement("option");
    placeholder.value = "";
    placeholder.innerText = "LH";
    placeholder.disabled = true;
    placeholder.hidden = true;
    select.appendChild(placeholder);

    LINE_HEIGHTS.forEach(lh => {
      const option = document.createElement("option");
      option.value = lh;
      option.innerText = lh;
      select.appendChild(option);
    });

    select.addEventListener("change", e => {
      const lh = e.target.value;
      const length = editor.getLength();

      editor.formatLine(0, length, "lineheight", lh || false);
    });

    container.appendChild(select);
    toolbar.appendChild(container);
  }, []);

  useEffect(() => {
    const editor = quillRef.current?.getEditor();
    const select = selectRef.current;
    if (!editor || !select) return;

    requestAnimationFrame(() => {
      const format = editor.getFormat();
      select.value = format.lineheight || "";
    });
  }, [value]);

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ align: [] }]
    ]
  };

  return (
    <div className="quill-wrapper">
      <ReactQuill
        ref={quillRef}
        value={value}
        onChange={onChange}
        theme="snow"
        modules={modules}
        placeholder="Type something..."
      />
    </div>
  );
}
